<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist ref="SetBtn" @help="help" @search="search" @reflash="reflash" @exps="exp"></buttonlist>
		<!-- 功能按钮 -->
		<el-card class="box-card">
			<el-row>
				<el-col :span="24" class="t">
					{{$t('getapi[6508]')}}
					<br />
					{{$t('getapi[6509]')}}
					<br />
					{{$t('getapi[6510]')}}
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="tt">
					<span class="demonstration">{{ $t('getapi[4053]') }}</span>
					<el-date-picker
						v-model="EndDate"
						type="daterange"
						align="right"
						unlink-panels
						range-separator="-"
						:start-placeholder="$t('getapi[4056]')"
						:end-placeholder="$t('getapi[4057]')"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
						:picker-options="pickerOptions"
						ref="pickref"
						@change="chengstime"
					></el-date-picker>
				</el-col>
				<el-button type="success" size="mini" @click="intidata" :disabled="!authority_count">{{$t('getapi[1979]')}}</el-button>
			</el-row>
		</el-card>
		<el-tabs type="border-card" @tab-click="tabclick" value="1">
			<el-tab-pane :label="$t('getapi[6511]')" name="1" id="xpane-1">
				<!-- 表格 -->
				<vxe-table
					ref="table1"
					:data="datajson.FTJLSJDT"
					v-loading="loading"
					:highlight-current-row="false"
					show-overflow="true"
					border
					stripe
					:auto-resize="true"
					size="mini"
					:height="tableHeight"
					header-row-class-name="headerclass"
					tab-click="selectInfo(0)"
					@selection-change="handleSelectionChange"
					style="width: 100%; margin-top:0px"
				>
					<vxe-table-column show-overflow field="客户编号" :title="$t('getapi[2583]')"></vxe-table-column>
					<vxe-table-column show-overflow field="单据号" :title="$t('getapi[3102]')"></vxe-table-column>
					<vxe-table-column show-overflow field="单据类型" :title="$t('getapi[3684]')"></vxe-table-column>
					<vxe-table-column show-overflow field="销售订单号" :title="$t('getapi[3884]')"></vxe-table-column>
					<vxe-table-column show-overflow field="销售件号" :title="$t('getapi[2800]')"></vxe-table-column>
					<vxe-table-column show-overflow field="销售件名称" :title="$t('getapi[3940]')"></vxe-table-column>
					<vxe-table-column show-overflow field="版本" :title="$t('getapi[113]')"></vxe-table-column>
					<vxe-table-column show-overflow field="计量单位" :title="$t('getapi[888]')"></vxe-table-column>
					<vxe-table-column field="不含税单价" :title="$t('getapi[1303]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.不含税单价 | thousandth4 }}
						</template>
					</vxe-table-column>
					<vxe-table-column show-overflow field="单据数量" :title="$t('getapi[2994]')" align="right"></vxe-table-column>
					<vxe-table-column field="金额" :title="$t('getapi[2102]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.金额 | thousandth2 }}
						</template>
					</vxe-table-column>
					<vxe-table-column show-overflow field="sales_rate" :title="$t('getapi[12832]')" align="right" v-if="userData.Login_DB == 'MLXY'"></vxe-table-column>
					<vxe-table-column show-overflow field="货币代码" :title="$t('getapi[3108]')"></vxe-table-column>
					<vxe-table-column show-overflow field="发生时间" :title="$t('getapi[3259]')"></vxe-table-column>
					<vxe-table-column field="转换金额CNY" :title="$t('getapi[6512]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.转换金额CNY | thousandth2 }}
						</template>
					</vxe-table-column>
					<vxe-table-column show-overflow field="用途" :title="$t('getapi[1866]')"></vxe-table-column>
				</vxe-table>
				<!-- 表格 -->
			</el-tab-pane>
			<el-tab-pane :label="$t('getapi[6513]')" name="2"><div id="main" :style="{ width: Cwidth + 'px', height: tableHeight + 'px' }"></div></el-tab-pane>
			<el-tab-pane :label="$t('getapi[6514]')" name="3">
				<!-- 表格 -->
				<el-table
					ref="table3"
					:data="datajson.TJJGDT"
					v-loading="loading"
					:highlight-current-row="false"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="tableHeight"
					:header-cell-style="{ 'text-align': 'center' }"
					header-row-class-name="headerclass"
					:cell-style="{ 'text-align': 'right' }"
					tab-click="selectInfo(0)"
					@selection-change="handleSelectionChange"
					style="width: 100%; margin-top:0px"
				>
					<el-table-column width="150" v-for="(item, ind) in TJJGDTs" :key="ind" show-overflow-tooltip :prop="item" :label="item"></el-table-column>
				</el-table>
				<!-- 表格 -->
			</el-tab-pane>
			<el-tab-pane :label="$t('getapi[6515]')" name="4"><div id="content" :style="{ width: Cwidth + 'px', height: tableHeight + 'px' }"></div></el-tab-pane>
			<el-tab-pane :label="$t('getapi[6516]')" name="5" id="xpane-5">
				<!-- 表格 -->
				<el-table
					ref="table5"
					:data="datajson.KHTJJGDT"
					v-loading="loading"
					:highlight-current-row="false"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="tableHeight"
					header-row-class-name="headerclass"
					tab-click="selectInfo(0)"
					@selection-change="handleSelectionChange"
					style="width: 100%; margin-top:0px"
				>
					<el-table-column show-overflow-tooltip prop="客户编号" :label="$t('getapi[2583]')" width="150"></el-table-column>
					<el-table-column prop="转换金额CNY" :label="$t('getapi[6512]')" align="right" width="150">
						<template slot-scope="scope">
							{{ scope.row.转换金额CNY | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="转换金额CNY万元" :label="$t('getapi[6517]')" align="right" width="150">
						<template slot-scope="scope">
							{{ scope.row.转换金额CNY万元 | thousandth2 }}
						</template>
					</el-table-column>
				</el-table>
				<!-- 表格 -->
			</el-tab-pane>
			<el-tab-pane :label="$t('getapi[6518]')" name="6" id="xpane-6">
				<!-- 表格 -->
				<el-table
					ref="table6"
					:data="datajson.KHFTJE_NEWDT"
					v-loading="loading"
					:highlight-current-row="false"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="tableHeight"
					header-row-class-name="headerclass"
					tab-click="selectInfo(0)"
					@selection-change="handleSelectionChange"
					style="width: 100%; margin-top:0px"
				>
					<el-table-column show-overflow-tooltip prop="客户编号" :label="$t('getapi[2583]')" width="80"></el-table-column>
					<el-table-column show-overflow-tooltip prop="客户名称" :label="$t('getapi[2584]')" width="220"></el-table-column>
					<el-table-column show-overflow-tooltip prop="货币代码" :label="$t('getapi[3108]')" width="80"></el-table-column>
					<el-table-column prop="结算总金额" :label="$t('getapi[6519]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.结算总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="槟城销售总金额" :label="$t('getapi[12833]')" align="right" v-if="userData.Login_DB == 'MLXY'">
						<template slot-scope="scope">
							{{ scope.row.槟城销售总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="常州销售总金额" :label="$t('getapi[12834]')" align="right" v-if="userData.Login_DB == 'MLXY'">
						<template slot-scope="scope">
							{{ scope.row.常州销售总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="发货总金额" :label="$t('getapi[6520]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.发货总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="退货总金额" :label="$t('getapi[6521]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.退货总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="其它费用金额" :label="$t('getapi[6522]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.其它费用金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="结算本位币总金额" :label="$t('getapi[6523]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.结算本位币总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="转换发货总金额CNY" :label="$t('getapi[6524]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.转换发货总金额CNY | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column show-overflow-tooltip prop="转换退货总金额CNY" :label="$t('getapi[6525]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.转换退货总金额CNY | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="其它费用本位币金额" :label="$t('getapi[6526]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.其它费用本位币金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="结算本位币总金额新" :label="$t('getapi[12590]')" align="right" v-if="notCNY">
						<template slot-scope="scope">
							{{ scope.row.结算本位币总金额新 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="转换发货总金额CNY新" :label="$t('getapi[12591]')" align="right" v-if="notCNY">
						<template slot-scope="scope">
							{{ scope.row.转换发货总金额CNY新 | thousandth2 }}
						</template>
					</el-table-column>
				</el-table>
				<!-- 表格 -->
			</el-tab-pane>
			<el-tab-pane :label="$t('getapi[13321]')" name="7" id="xpane-7">
				<!-- 表格 -->
				<el-table
					ref="table7"
					:data="datajson.KHFTJE_WTMDT "
					v-loading="loading"
					:highlight-current-row="false"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="tableHeight"
					header-row-class-name="headerclass"
					tab-click="selectInfo(0)"
					@selection-change="handleSelectionChange"
					style="width: 100%; margin-top:0px"
				>
					<el-table-column show-overflow-tooltip prop="客户编号" :label="$t('getapi[137]')" width="80"></el-table-column>
					<el-table-column show-overflow-tooltip prop="客户名称" :label="$t('getapi[546]')" width="220"></el-table-column>
					<el-table-column show-overflow-tooltip prop="货币代码" :label="$t('getapi[3108]')" width="80"></el-table-column>
					<el-table-column prop="结算总金额" :label="$t('getapi[6519]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.结算总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="槟城销售总金额" :label="$t('getapi[12833]')" align="right" v-if="userData.Login_DB == 'MLXY'">
						<template slot-scope="scope">
							{{ scope.row.槟城销售总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="常州销售总金额" :label="$t('getapi[12834]')" align="right" v-if="userData.Login_DB == 'MLXY'">
						<template slot-scope="scope">
							{{ scope.row.常州销售总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="发货总金额" :label="$t('getapi[6520]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.发货总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="退货总金额" :label="$t('getapi[6521]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.退货总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="其它费用金额" :label="$t('getapi[6522]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.其它费用金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="结算本位币总金额" :label="$t('getapi[6523]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.结算本位币总金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="转换发货总金额CNY" :label="$t('getapi[6524]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.转换发货总金额CNY | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column show-overflow-tooltip prop="转换退货总金额CNY" :label="$t('getapi[6525]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.转换退货总金额CNY | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="其它费用本位币金额" :label="$t('getapi[6526]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.其它费用本位币金额 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="结算本位币总金额新" :label="$t('getapi[12590]')" align="right" v-if="notCNY1">
						<template slot-scope="scope">
							{{ scope.row.结算本位币总金额新 | thousandth2 }}
						</template>
					</el-table-column>
					<el-table-column prop="转换发货总金额CNY新" :label="$t('getapi[12591]')" align="right" v-if="notCNY1">
						<template slot-scope="scope">
							{{ scope.row.转换发货总金额CNY新 | thousandth2 }}
						</template>
					</el-table-column>
				</el-table>
				<!-- 表格 -->
			</el-tab-pane>
		</el-tabs>

		<!-- 分页 -->
	</div>
</template>

<script>
import Common from '@/components/Common';
import echarts from 'echarts';
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
	name: 'salaccoountmonchart',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight-325
        }
    },
	data() {
		return {
			pickerOptions: {
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					},
					{
						text: '最近半年',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 184);
							picker.$emit('pick', [start, end]);
						}
					}
				]
			},
			BeginDate: '',
			EndDate: [],
			showloading: '',
			DbTbNames: '', //表名
			datajson: [],
			PageIndex: 1,
			PageSize: 50,
			SelectIndex: '1',
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			Cwidth: window.innerWidth - 300,
			types: 1,
			sheetname:1,
			TJJGDTs: [],
			TJJGDTss: [],
			cjjson: [],
			cx: [],
			cxy: [],
			cxx: [],
			cht: '1',
			cht1: '2',
			authority_count: false, // 权限统计
            notCNY: false,//人民币是否为本币
			notCNY1: false,//人民币是否为本币
            userData: [], // 用户信息
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
		let that = this;
	},
	mounted() {
		console.log('mounted');
		let that = this;
        that.userData = JSON.parse(sessionStorage.getItem('userData'));
		that.EndDate = [];
		that.EndDate.push(that.getCurrentMonthFirst());
		that.EndDate.push(that.getCurrentMonthLast());
		//that.EndDate = ["2021-5-1","2021-5-20"];

		//that.$refs.pickref.$emit('pick', [that.EndDate[0], that.EndDate[1]]);
		//that.intidata();
		that.authority();
	},
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1017]"),this.$t("getapi[14]"));
        },
		//按钮操作权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			// 是否有权限执行统计
			if (that.$limits.authority('plv4', 133, 1) > 0) {
				that.authority_count = true;
			} else {
				that.authority_count = false;
			}
			//只读权
			if (that.$limits.authority('plv2', 122, 1) == 1) {
				that.$refs.SetBtn.SetButtonEnable('');
			}

			if (that.$limits.authority('plv2', 122, 1) == 2) {
				//操作权
				if (that.$limits.authority('plv3', 122, 1) == 1) {
					//编辑级
					that.$refs.SetBtn.SetButtonEnable('export');
				} else if (that.$limits.authority('plv3', 122, 1) == 2) {
					//删除级
					that.$refs.SetBtn.SetButtonEnable('export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('');
				}
			}
		},
		/**
		 * 获取当前月的第一天
		 */
		getCurrentMonthFirst() {
			var date = new Date();
			date.setDate(1);
			return date;
		},
		/**
		 * 获取当前月的最后一天
		 */
		getCurrentMonthLast() {
			var date = new Date();
			var currentMonth = date.getMonth();
			var nextMonth = ++currentMonth;
			var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
			var oneDay = 1000 * 60 * 60 * 24;
			return new Date(nextMonthFirstDay - oneDay);
		},
		tabclick(e) {
			let that = this;
			let name = e.name;
			that.sheetname = e.name
			if (name == '1') {
				that.types = 1;
			}
			else if (name == '3' || name == '5') {
				that.types = 3;
			}
			else if (name == '6') {
				that.types = 2;
			}
			else if (name == '7') {
				that.types = 4;
			}
			else {
				that.types = 1;
			}

			if (e.label == '按客户按月统计图表') {
				that.showchar('main');
			}
			if (e.label == '按客户统计图表') {
				that.showchars('content');
			}
			that.SelectIndex = e.name
            that.$nextTick(function () {
                that.$processdata.initForm(that.SelectIndex)
            })
		},
		//获取查询条件
		serclick(val) {
			console.log(val);
			this.queryData = val;
			this.intidata();
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Co_id + ',';
			}
			console.log(that.selectIDData);
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
			this.intidata();
			this.authority();
		},
		//编辑
		// editInfo(row) {
		// 	console.log(row);
		// 	let that = this;

		// },
		chengstime(e) {},
		// 获取数据
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			let parm = {
				type: that.types,
				BeginDate: that.EndDate[0],
				EndDate: that.EndDate[1]
			};
			that.showloading = that.openLoading();
			console.log(parm);
			that.$http.urlpost('Sal/Account/GetSalMonthTJList', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.TJJGDTs = [];
					that.datajson = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
					let jss = res.DataContent.TJJGDT[0];
					let json = [];
					that.cx = [];
					that.cxx = [];
					that.cxy = [];
					that.cjjson = [];
					that.TJJGDTss = [];
					res.DataContent.KHTJJGDT.forEach(function(item,index) {
						
						if(index<10){
							that.cxx.push(item.客户编号);
							that.cxy.push(item.转换金额CNY万元);
							res.DataContent.TJJGDT.forEach(function(items, ind) {
								if(item.客户编号==items.客户编号){
									that.cjjson.push(items.客户编号);
										let fs = [-60, 0];
										if (index % 2 == 0) {
											fs = [20, 0];
										}
										let pm = { name: '', data: [], type: 'line',smooth: false};
										pm.label = {
											normal: {
												show: true,
												offset: fs,
												position: 'center'
											}
										};
										pm.name = items.客户编号;
										pm.emphasis = {
											focus: 'series',
											itemStyle: {
												shadowBlur: 10,
												shadowOffsetX: 0,
												shadowColor: 'rgba(0, 0, 0, 0.5)'
											}
										};
										let ps = new Array();
										for (var key in items) {
											if (pm.name != items[key]) {
												console.log(items[key]);
												ps.push(items[key]);
											}
											pm.data = ps;
										}
										that.cx.push(pm);
									that.showloading.close();
								}
									
							});
						}
					});
					for (var key in jss) {
						that.TJJGDTs.push(key);
						if (key != '客户编号') {
							that.TJJGDTss.push(key);
						}
					}
					if(that.datajson.KHFTJE_NEWDT.length > 0){
						if(that.datajson.KHFTJE_NEWDT[0]['结算本位币总金额新']){
							that.notCNY = true
						} else {
							that.notCNY = false
						}
					}
					if(that.datajson.KHFTJE_WTMDT && that.datajson.KHFTJE_WTMDT.length > 0){
						if(that.datajson.KHFTJE_WTMDT[0]['结算本位币总金额新']){
							that.notCNY1 = true
						} else {
							that.notCNY1 = false
						}
					}
				}
				that.showchar('main');
				that.showchars('content');
				that.loading = false;
				that.authority();
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
			});
		},

		// 查询
		search() {
			this.isVisible = true;
			this.$refs.ser.clearInput(this.isVisible, 'SALCOLineViewInfo');
		},
		// 刷新
		reflash() {
			this.intidata();
		},
/*		//弹出框关闭前提示
		closemodel(e) {
		    let that = this;
			this.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生变更是否保存后关闭?'
				confirmButtonText: that.$t('getapi[1146]'),
				cancelButtonText: that.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {})
				.catch(() => {});
		},*/
		showchar(id) {
			console.log('jj');
			let that = this;
			console.log(that.cht);
			that.cht = echarts.init(document.getElementById(id));
			let option = {
				title: {
					text: '销售月统计'
				},
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					data: that.cjjson,
					type: 'scroll',
					orient: 'horizontal',
					left: 150,
					icon:'circle',
					top: 5,
				},
				grid: {
					left: '3%',
					right: '5%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: that.TJJGDTss
				},
				yAxis: {
					type: 'value',
					axisLabel: {
						formatter: '{value} （万元）'
					}
				},
				toolbox: {
					show: true,
					feature: {
						dataZoom: {
							yAxisIndex: 'none'
						},
						dataView: { readOnly: false },
						magicType: { type: ['line', 'bar'] },
						restore: {},
						saveAsImage: {}
					}
				},
				series: that.cx
			};
			that.cht.clear();
			that.cht.setOption(option);
		},
		showchars(id) {
			let that = this;
			console.log('jj>>>>');
			that.cht1 = '';
			console.log(that.cht1);
			that.cht1 = echarts.init(document.getElementById(id));
			let option1 = {
				tooltip: {
					trigger: 'axis'
				},
				grid: {
					left: '3%',
					right: '15%',
					bottom: '3%',
					containLabel: true
				},
				toolbox: {
					feature: {
						saveAsImage: {}
					}
				},
				xAxis: {
					type: 'category',
					data: that.cxx
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						data: that.cxy,
						type: 'bar',
						label: {
							normal: {
								show: false
								// position: 'left'
							}
						}
					}
				]
			};

			that.cht1.setOption(option1);
		},
		//导出·
		exp() {
			let that = this;
			/*that.loading = true;
			let parm = {
				type: that.types,
				BeginDate: that.EndDate[0],
				EndDate: that.EndDate[1],
                LangType: that.$processdata.getLang(),
                fromname: that.$t('getapi[6511]')
			};
			if (that.types == 2){
				parm.fromname = that.$t('getapi[6518]')
			} else if(that.types == 3){
                parm.fromname = that.$t('getapi[6516]')
			}
			else if(that.types == 4){
                parm.fromname = that.$t('getapi[13321]')
			}
			that.$http.urlpost('Sal/Account/GetSalMonthTJListToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				// else {
				// 	that.$message.error(res.Msg);
				// }
				that.loading = false;
			});*/
			let wb = null;
			let name = '';
			if(that.sheetname == 1){
			    const allData = this.datajson.FTJLSJDT
                const wb = XLSX.utils.book_new()
                const wsData = [
                    [this.$t('getapi[2583]'),this.$t('getapi[3102]'),this.$t('getapi[3684]'),this.$t('getapi[3884]'),
					this.$t('getapi[2800]'),this.$t('getapi[3940]'),this.$t('getapi[113]'),this.$t('getapi[888]'),
					this.$t('getapi[1303]'),this.$t('getapi[2994]'),this.$t('getapi[12832]'),this.$t('getapi[3108]'),
					this.$t('getapi[3259]'),this.$t('getapi[6512]'),this.$t('getapi[1866]')],
                    ...allData.map(item => [item['客户编号'] || '', item['单据号'] || '', item['单据类型'] || '',item['销售订单号'] || '',
                        item['销售件号'] || '',item['销售件名称'] || '',item['版本'] || '',item['计量单位'] || '',
                        item['不含税单价'] || '',item['单据数量'] || '',item.sales_rate || '',item['货币代码'] || '',
                        item['发生时间'] || '',item['转换金额CNY'] || '',item['用途'] || ''])
                ]
                const ws = XLSX.utils.aoa_to_sheet(wsData)

                // 将工作表添加到工作簿
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

                // 导出文件
                const wbout = XLSX.write(wb, { bookType: 'xlsx',bookSST: true, type: 'array' })
                try {
                    FileSaver.saveAs(new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }), that.$t('getapi[6511]')+'.xlsx');  //table是自己导出文件时的命名，随意
                } catch (e)
                {
                    if (typeof console !== 'undefined')
                        console.log(e, wbout)
                }
                return wbout
                /*const tableElement = this.$refs.table1 ? this.$refs.table1.$el : null;
                wb = XLSX.utils.table_to_book(tableElement,{raw:true});
				name = that.$t('getapi[6511]')*/
			} else {
                if(that.sheetname == 3){
                    const tableElement = this.$refs.table3 ? this.$refs.table3.$el : null;
                    wb = XLSX.utils.table_to_book(tableElement,{raw:true});
                    name = that.$t('getapi[6514]')
                } else if(that.sheetname == 5){
                    const tableElement = this.$refs.table5 ? this.$refs.table5.$el : null;
                    wb = XLSX.utils.table_to_book(tableElement,{raw:true});
                    name = that.$t('getapi[6516]')
                } else if(that.sheetname == 6){
                    const tableElement = this.$refs.table6 ? this.$refs.table6.$el : null;
                    wb = XLSX.utils.table_to_book(tableElement,{raw:true});
                    name = that.$t('getapi[6518]')
                } else if(that.sheetname == 7){
                    const tableElement = this.$refs.table7 ? this.$refs.table7.$el : null;
                    wb = XLSX.utils.table_to_book(tableElement,{raw:true});
                    name = that.$t('getapi[13321]')
                } else {
                    return
                }
                for(let obj in wb.Sheets.Sheet1){
                    if(!isNaN(wb.Sheets.Sheet1[obj].v)){
                        wb.Sheets.Sheet1[obj].v = wb.Sheets.Sheet1[obj].v.toString().replace(/\d+/, function(n){ // 先提取整数部分
                            return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                                return $1+",";
                            });
                        })
                    }
                }
                let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
                try {
                    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), name+'.xlsx');  //table是自己导出文件时的命名，随意
                } catch (e)
                {
                    if (typeof console !== 'undefined')
                        console.log(e, wbout)
                }
                return wbout
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.t.el-col.el-col-24 {
	color: blue;
	font-size: small;
	line-height: 22px;
	margin-bottom: 10px;
}

.tt {
	display: contents;
}

.el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange {
	margin: 0 10px;
}
</style>
